'use client';

import {
    BarList,
    Card,
    Tab,
    TabGroup,
    TabList,
    TabPanel,
    TabPanels,
} from '@tremor/react';
import { useState } from 'react';

// Eliminado el tipo : number y el retorno : string
const valueFormatter = (number) =>
    `${Intl.NumberFormat('us').format(number).toString()}`;

// Eliminadas las interfaces DataItem, BarlistProps y TabConfig

const BarlistChart = ({ data1, data2 }) => {

    const tab1Data = data1.map(item => ({ name: item.name, value: item.quantity }));
    const tab2Data = data2.map(item => ({ name: item.name, value: item.quantity }));

    const [extended, setExtended] = useState(false);

    // Estado para el hover - Eliminado el genérico <string | undefined>
    const [selectedItem, setSelectedItem] = useState(undefined);

    const tabs = [
        { name: "Departamentos", data: tab1Data },
        { name: "Municipios", data: tab2Data },
    ];

    const handleBarHover = (item) => {
        setSelectedItem(item.name);
    };

    const clearSelectedItem = () => {
        setSelectedItem(undefined);
    };

    return (
        <div className={`w-full overflow-hidden p-6 shadow rounded ${extended ? '' : 'h-[360px]'}`}>
            <TabGroup defaultIndex={0}>
                <div className="flex items-center justify-between">
                    <p className="font-medium text-tremor-content-strong dark:text-dark-tremor-content-strong">
                        Ubicaciones
                    </p>
                    <TabList variant="solid" className="overflow-visible bg-transparent p-0">
                        {tabs.map(item => (
                            <Tab key={item.name} value={item.name}
                                 className="font-medium ui-selected:text-tremor-content-strong ui-selected:dark:text-dark-tremor-content-strong">
                                {item.name}
                            </Tab>
                        ))}
                    </TabList>
                </div>

                <TabPanels className="mt-6">
                    {tabs.map(item => (
                        <TabPanel key={item.name}>
                            <div className={`overflow-hidden p-6 ${extended && item.data.length > 6 ? '' : 'max-h-[460px]'}`}>
                                <BarList 
                                    data={item.data} 
                                    valueFormatter={valueFormatter} 
                                    onValueChange={handleBarHover}
                                />
                            </div>

                            {item.data.length > 7 &&
                                <div className={`flex justify-center ${extended
                                    ? 'px-6 pb-6'
                                    : 'absolute inset-x-0 bottom-0 rounded-b-tremor-default bg-gradient-to-t from-tremor-background to-transparent py-7 dark:from-dark-tremor-background'
                                    }`}>
                                    <button
                                        className="flex items-center justify-center rounded-tremor-small border border-tremor-border bg-tremor-background px-2.5 py-2 text-tremor-default font-medium text-tremor-content-strong shadow-tremor-input hover:bg-tremor-background-muted dark:border-dark-tremor-border dark:bg-dark-tremor-background dark:text-dark-tremor-content-strong dark:shadow-dark-tremor-input hover:dark:bg-dark-tremor-background-muted"
                                        onClick={() => setExtended(!extended)}
                                    >
                                        {extended ? 'Ver menos' : 'Ver más'}
                                    </button>
                                </div>}
                        </TabPanel>
                    ))}
                </TabPanels>
            </TabGroup>
        </div>
    );
}

export default BarlistChart;